module.exports = __webpack_public_path__ + "static/media/foot-left-front.0b941f66.png";